
export const baseURL = "https://doxy-backend-cu9t.onrender.com"

export const documentsApiRoute = "/api/document"
